// Corporate Actions: Desk elections. The Desk side of the corporate actions
// of `wealth.ops.corporate-actions` (ADR-0027): the page where the IM records
// the election of each account, the deadlines card of the Desk Dashboard and
// the elections that wait for the IM on the Desk worklist.
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';
import { coacActionsQuery } from '@/lib/coac/hooks';
import type { CoacActionRow } from '@septima/contract';
import { caElectionItems } from '@/pages/desk/actions/worklist';

const DeadlinesCard = lazy(() =>
    import('./corporate-actions-desk-elections.slots').then((m) => ({
        default: m.DeadlinesCard,
    })),
);

export default defineWebFeature({
    id: 'wealth.ops.corporate-actions.desk-elections',
    routes: [
        {
            frontend: 'desk',
            path: 'corporate-actions',
            lazy: () => import('@/pages/desk/corporate-actions/page'),
        },
        {
            // SEP-379. The full page of the pane of the "My decisions" tab.
            frontend: 'desk',
            path: 'corporate-actions/:id',
            lazy: () => import('@/pages/desk/corporate-actions/detail/page'),
        },
    ],
    nav: [
        {
            frontend: 'desk',
            key: 'corporate-actions',
            label: 'Corporate Actions',
            href: '/desk/corporate-actions',
            icon: 'Building2',
            group: 'tasks-alerts',
            order: 320,
        },
    ],
    slots: {
        'desk.dashboard.cards': [
            {
                key: 'ca-deadlines',
                order: 10,
                span: 4,
                rows: 2,
                title: 'Corporate action deadlines',
                summary: 'The open corporate actions of your book, soonest deadline first.',
                // The card reads the corporate actions with its own hook, so the
                // page cannot know the count. The card has no count, and it
                // never collapses.
                Component: DeadlinesCard,
            },
        ],
        'desk.worklist.sources': [
            {
                key: 'ca-elections',
                order: 30,
                query: () => coacActionsQuery(),
                select: (input) => ({
                    items: caElectionItems((input as CoacActionRow[] | undefined) ?? []),
                    tile: {
                        label: 'CA Elections Required',
                        severity: 'amber',
                        to: '/desk/corporate-actions',
                        ariaLabel: 'CA Elections Required: open Corporate Actions',
                    },
                }),
            },
        ],
    },
});
